import * as React from 'react'

import { IClient } from 'interfaces/IClient'
import { ICompany } from 'interfaces/ICompany'
import { IInvoice } from 'interfaces/IInvoice'

export interface IAuthContext {
  loaded?: boolean
  clients: { [clientKey: string]: IClient }
  companies: { [companyKey: string]: ICompany }
  company: string | null
  invoices: { [invoiceKey: string]: IInvoice }
  user: firebase.User | null
  logo: string | null
  getLogo?: () => void
  setCompany?: (key: string) => void
}

const AuthContext = React.createContext<IAuthContext>({
  loaded: false,
  clients: {},
  companies: {},
  company: null,
  invoices: {},
  user: null,
  logo: null,
})

export default AuthContext



// WEBPACK FOOTER //
// ./src/context/AuthContext.ts